var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"income-and-outgo block-contents"},[_c('div',{staticClass:"box-content"},[_c('div',{staticClass:"box-content-inner at-syushi"},[_c('router-view',{attrs:{"startDate":_vm.startDate,"endDate":_vm.endDate}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }